<!--
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-04-04 19:29:29
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-07-05 14:48:43
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\components\UploadFile\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="wrap">
    <el-upload
      :show-file-list="false"
      :action="uploadUrl"
      :headers="headers"
      :before-upload="beforeHandle"
      :on-success="success"
      :on-error="error"
      :disabled="isUploading"
    >
      <el-button type="primary" class="licence" plain :loading="isUploading">
        {{ isUploading ? '上传中...' : btnText }}<el-icon><CameraFilled v-if="!isUploading" /></el-icon>
      </el-button>
    </el-upload>

    <previewFileBtn v-if="url" :url="url" :btn-text="viewText" :pre-path="prePath" />
  </div>
</template>
<script setup>
import { ref } from 'vue';
import Compressor from 'compressorjs';
import previewFileBtn from './previewFile.vue';
import { ElMessage as Message } from 'element-plus';
import { baseUrl, uploadUrl as uploadApiUrl } from '../../config/request.js';
import accountManager from '../../utils/account';

const props = defineProps({
  btnText: {
    type: String,
    default: '上传文件',
  },
  viewText: {
    type: String,
    default: '查看文件',
  },
  uploadUrl: {
    type: String,
    default: baseUrl + uploadApiUrl,
  },
  headers: {
    type: Object,
    default() {
      return accountManager.getAuthHeader();
    },
  },
  prePath: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['success']);

const url = defineModel({ type: [String, Array], default: '' });

const isUploading = ref(false);

//文件上传成功
function success(res) {
  url.value = res.data || '';
  emit('success', url.value);
  isUploading.value = false;
}
//上传失败
function error() {
  isUploading.value = false;
}

//文件上传前判断处理
async function beforeHandle(file) {
  const { size, name } = file;
  const ImageTypes = ['jpg', 'JPG', 'png'];
  const fileTypes = [...ImageTypes, 'pdf'];
  const fileType = name.slice(name.lastIndexOf('.') + 1);
  if (!fileTypes.includes(fileType)) {
    //类型不符
    Message.warning('不接受此类型文件');
    return false;
  }
  const isImage = ImageTypes.includes(fileType);
  if (isImage) {
    //图片
    if (size > 1024 * 1024 * 2) {
      //大于2M则压缩
      file = await compress(file);
    }
  }
  isUploading.value = true;
  return file;
}

//压缩图片
function compress(file) {
  return new Promise((resolve) => {
    new Compressor(file, {
      strict: true, //若压缩图像大于原始图像则使用原始图像
      checkOrientation: true, //自动调整图像方向
      maxWidth: 1920,
      maxHeight: 1080,
      quality: 0.6,
      convertSize: 2000000,
      success(result) {
        resolve(result);
      },
    });
  });
}
</script>
<style lang="scss" scoped>
.wrap {
  display: flex;
  align-items: center;
}
.licence {
  display: flex;
  width: 100px;
  height: 100px;
  padding: 28px;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  background: #6d9fff73;
  border: none;
  i {
    color: #fff;
    font-size: 20px;
  }
}
.el-link.el-link--primary {
  // color: #fff;
  margin-left: 10px;
}
</style>
